/**
 * AnnotationToolbar Component
 * Tool selection for drawing annotation shapes
 */

import React from 'react';
import { FiMousePointer, FiSquare, FiCircle } from 'react-icons/fi';

const tools = [
  { id: 'view', icon: FiMousePointer, label: 'Select' },
  { id: 'rectangle', icon: FiSquare, label: 'Rectangle' },
  { id: 'circle', icon: FiCircle, label: 'Circle' }
];

export default function AnnotationToolbar({
  mode = 'view',
  onModeChange = () => {},
  disabled = false,
  className = ''
}) {
  return (
    <div className={`flex items-center gap-1 bg-black/60 rounded-lg p-1 ${className}`}>
      {tools.map(tool => {
        const Icon = tool.icon;
        const isActive = mode === tool.id;

        return (
          <button
            key={tool.id}
            onClick={() => onModeChange(tool.id)}
            disabled={disabled}
            title={tool.label}
            className={`p-2 rounded transition-all ${
              isActive
                ? 'bg-white text-black'
                : 'text-white/80 hover:bg-white/20 hover:text-white'
            } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <Icon size={18} />
          </button>
        );
      })}
    </div>
  );
}
